import PropTypes from "prop-types";
import { useContext } from "react";
import { useTracking } from "@context/Tracking";
import { CartContext } from "@context/CartProvider";
import { GIFT_PACKAGES_HANDLES } from "@constants/GiftPackages";
import GiftIcon from "@svgs/gift-new.svg";

function GiftPackaging({ openPackagingPopup, lines }) {
  const { updateCartNote, removeSingleProductsFromCart } = useContext(CartContext);

  const { trackGiftPackagingActions } = useTracking();

  const packageInCart = lines.find((line) =>
    GIFT_PACKAGES_HANDLES.includes(line.variant.product.handle)
  );

  const hasGiftPackageInCart = Boolean(packageInCart);

  const handleGiftPackagingClick = () => {
    openPackagingPopup();
    trackGiftPackagingActions({ action: "add_packaging_click" });
  };

  const handleRemoveGiftPackagingFromCart = async () => {
    trackGiftPackagingActions({
      action: "remove_packaging_click",
      productId: packageInCart?.variant?.product?.id,
    });
    try {
      await removeSingleProductsFromCart({ lineToRemove: packageInCart });
      await updateCartNote("");
    } catch (error) {
      console.error("Failed to remove gift packaging and note from cart:", error);
    }
  };

  const handleEditGiftPackaging = () => {
    openPackagingPopup();
    trackGiftPackagingActions({
      action: "edit_packaging_click",
      productId: packageInCart?.variant?.product?.id,
    });
  };

  return (
    <div className="flex justify-between items-center py-[12px] px-[15px] mx-[15px] desktop:mx-[20px] mt-[15px] rounded-[4px] border border-black">
      <div className="flex items-center gap-[8px] ">
        <GiftIcon width={15} height={15} stroke="black" />
        <p className="typo-body">
          {hasGiftPackageInCart ? "Gift packaging added" : "Is this order a gift?"}
        </p>
      </div>
      {hasGiftPackageInCart ? (
        <div className="flex gap-[12px]">
          <button
            type="button"
            className="typo-body underline bold"
            onClick={handleEditGiftPackaging}
          >
            Edit
          </button>
          <button
            type="button"
            className="typo-body underline bold"
            onClick={handleRemoveGiftPackagingFromCart}
          >
            Remove
          </button>
        </div>
      ) : (
        <button
          type="button"
          className="typo-body underline bold"
          onClick={handleGiftPackagingClick}
        >
          Add Gift Packaging
        </button>
      )}
    </div>
  );
}

GiftPackaging.propTypes = {
  openPackagingPopup: PropTypes.func.isRequired,
  lines: PropTypes.arrayOf(
    PropTypes.shape({
      variant: PropTypes.shape({
        product: PropTypes.shape({
          handle: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    })
  ).isRequired,
};

export default GiftPackaging;
